import React from 'react'

import { ROUTE_NAME } from '../constants'

import Index from '../../../components/Index'
import List from './List'
import Details from './Details'
import Create from './Create'
import Delete from './Delete'

const IncidentCategoryBuffers = () => (
  <Index
    routeName={ROUTE_NAME}
    List={List}
    Details={Details}
    Delete={Delete}
    Create={Create}
  />
)

export default IncidentCategoryBuffers
